module.exports = __webpack_public_path__ + "img/272.58928509.jpg";